import { css } from '@emotion/react';

export const contentContainer = css`
  border: none;
`;

export const contentBody = css`
  height: 100%;
`;
